<template>
<v-footer class="footer-main">
    <v-container>
        <v-row class="footer-top" align="start" justify="space-between">

            <!-- BRAND -->
            <v-col cols="12" md="3" class="mb-8 mb-md-0">
                <h3 class="footer-brand">MNK Agriventures</h3>
                <p class="footer-desc">
                   {{$t('Motto')}}
                </p>
                <v-btn class="btn-contact" rounded flat="" large to="/contact">
                     {{ $t('Get in Touch') }} <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
            </v-col>

            <!-- QUICK LINKS -->
            <v-col cols="12" md="3" class="mb-8 mb-md-0">
                <h4 class="footer-title">{{$t('QuickLinks')}}</h4>
                <ul class="footer-links">
                    <li v-for="(link, index) in links" :key="index">
                        <a class="footer-link" @click="navigate(link.route)">
                            {{ $t(link.name) }}
                        </a>
                    </li>
                </ul>
            </v-col>

            <!-- CONTACT -->
            <v-col cols="12" md="3" class="mb-8 mb-md-0">
                <h4 class="footer-title">{{ $t('ContactInfo') }}</h4>
                <p>{{$t('Email')}}: <a href="mailto:info@mnkagriventures.com" class="footer-link">{{form.email}}</a></p>
                <p>{{$t('Phone')}}: <a href="https://wa.me/255712345678" target="_blank" class="footer-link">+{{form.phone}}</a></p>
                <p>{{$t('Location')}}: {{form.location}} <br>{{form.city}}</p>
              
            </v-col>

            <!-- SOCIAL -->
            <v-col cols="12" md="3">
                <h4 class="footer-title">{{ $t('FollowUs') }}</h4>
                <div class="social-icons">
                    <!-- Facebook -->
                    <a href="https://www.facebook.com/MNK Agriventures LTD  " target="_blank" rel="noopener" class="social-icon">
                        <v-icon size="28">mdi-facebook</v-icon>
                    </a>

                    <!-- WhatsApp -->
                    <a href="https://wa.me/255764238790" target="_blank" rel="noopener" class="social-icon">
                        <v-icon size="28">mdi-whatsapp</v-icon>
                    </a>

                    <!-- Email -->
                    <a :href="`mailto:${form.email}`" class="social-icon">
                        <v-icon size="28">mdi-email</v-icon>
                    </a>

                    <!-- Instagram -->
                    <a href="https://www.instagram.com/mnk_agriventuresltd" target="_blank" rel="noopener" class="social-icon">
                        <v-icon size="28">mdi-instagram</v-icon>
                    </a>
                </div>
            </v-col>
        </v-row>

        <!-- COPYRIGHT -->
        <v-row class="footer-bottom mt-12">
            <v-col cols="12" class="text-center">
                <p class="copyright">
                    &copy; {{ new Date().getFullYear() }} MNK Agriventures Ltd. {{$t('AllRightsReserved')}}.
                </p>
            </v-col>
        </v-row>
    </v-container>
</v-footer>
</template>

<script>
import axios from 'axios';
export default {
    name: "FooterSection",
    data() {
        return {
            form: {
                email: null,
                phone: null,
                location: null,
                city: null
            },
            links: [{
                    name: "Home",
                    route: "/"
                },
                {
                    name: "Who We Are",
                    route: "/about-us"
                },
                {
                    name: "What We Do",
                    route: "/services"
                },
                {
                    name: "Media & Updates",
                    route: "/media"
                },
            ],
        };
    },
    mounted() {
        this.loadAddress();
    },
    methods: {
        navigate(route) {
            this.$router.push(route);
            this.drawer = false;
        },
        async loadAddress() {
            try {
                const response = await axios.get("/company-address", {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`
                    },
                });

                if (response.data.data) {
                    this.form = {
                        ...response.data.data
                    };
                }
            } catch (error) {
                console.error("Failed to load company address:", error);
                // Optionally show a friendly toast or message
            }
        },
    },
};
</script>

<style scoped>
/* FOOTER BASE */
.footer-main {
    background: #2e7d32;
    color: #fff;
    padding-top: 3rem;
    padding-bottom: 2rem;

}

/* Brand */
.footer-brand {
    font-size: 1.8rem;
    font-weight: 700;
    margin-bottom: 1rem;
    background: linear-gradient(135deg, #B87C4C, #cef7de);
    -webkit-background-clip: text;
    /* for Safari / older Chrome */
    background-clip: text;
    /* standard property for modern browsers */
    -webkit-text-fill-color: transparent;
    /* for Safari / Chrome */
    color: transparent;
    /* standard fallback */
}

.footer-desc {
    font-size: 0.95rem;
    line-height: 1.7;
    color: #e0e0e0;
    margin-bottom: 1rem;
}

/* CTA Button */
.btn-contact {
    background: linear-gradient(135deg, #B87C4C, #06923E);
    color: #fff;
    font-weight: 600;
    text-transform: uppercase;
    transition: all 0.3s ease;
}

.btn-contact:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

/* Titles */
.footer-title {
    font-weight: 700;
    font-size: 1.15rem;
    margin-bottom: 1rem;
    color: #fff;
}

/* Quick Links */
.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;

}

.footer-links li {
    margin-bottom: 0.5rem;
}

.footer-link {
    color: #ffffff;
    text-decoration: none;
    font-size: 0.95rem;
    transition: all 0.3s ease;
    cursor: pointer;
}

.footer-link:hover {
    color: #B87C4C;
    transform: translateX(4px);
}

/* Social Icons */
.social-icons {
    display: flex;
    gap: 12px;
    margin-top: 1rem;
}

.social-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.1);
    width: 44px;
    height: 44px;
    border-radius: 50%;
    color: white;
    transition: all 0.3s ease;
    text-decoration: none;
}

.social-icon:hover {
    transform: scale(1.2);
    background: #B87C4C;
}

/* COPYRIGHT */
.footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    padding-top: 1.5rem;
}

.copyright {
    font-size: 0.85rem;
    letter-spacing: 0.5px;
    color: #f0f0f0;
}

/* RESPONSIVE */
@media (max-width: 960px) {
    .footer-top {
        text-align: center;
    }

    .social-icons {
        justify-content: center;
    }
}
</style>
